module.exports = __webpack_public_path__ + "img/pipeline-arrow.f8cba66d.svg";